import { PlaceActivationDto } from 'gleblu-socket-api';

import PlaceActivationData from '../form/PlaceActivationData';
import * as companyAdapter from './CompanyAdapter';
import * as contactAdapter from './ContactAdapter';
import * as placeAdapter from './PlaceAdapter';
import * as placeUserAdapter from './PlaceUserAdapter';

export function fromDto(placeActivationDto: PlaceActivationDto): PlaceActivationData {
  const company = companyAdapter.fromDto(placeActivationDto.company);
  const placeUser = placeUserAdapter.fromDto(placeActivationDto.placeUser);
  const contact = contactAdapter.fromDto(placeActivationDto.contact);
  const place = placeAdapter.fromDto(placeActivationDto.place);
  return { company, placeUser, contact, place };
}

export function toDto(placeActivationData: PlaceActivationData): PlaceActivationDto {
  const company = companyAdapter.toDto(placeActivationData.company);
  const placeUser = placeUserAdapter.toDto(placeActivationData.placeUser);
  const contact = contactAdapter.toDto(placeActivationData.contact);
  const place = placeAdapter.toDto(placeActivationData.place);
  return { company, placeUser, contact, place };
}
